export default "__VITE_ASSET__6TECaHkC__"